var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "markets-ui-popover",
    {
      ref: "settingPopover",
      class: _vm.namespace(),
      attrs: {
        namespaced: _vm.namespaced,
        visible: _vm.visible,
        target: _vm.target,
        skin: _vm.skin,
        width: _vm.width
      },
      on: { hide: _vm.hidePopover }
    },
    [
      _c(
        "header",
        {
          class: [
            _vm.mdsNS("popover__header"),
            _vm.namespace("__header"),
            _vm.skinStyle
          ]
        },
        [
          _c("div", { class: _vm.namespace("__header-title") }, [
            _vm.showBack
              ? _c(
                  "button",
                  {
                    class: _vm.mdsNS("button button--icon-only"),
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.clickBack($event)
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        class: _vm.mdsNS(
                          "icon button__icon button__icon--right"
                        )
                      },
                      [
                        _c(
                          "use",
                          { attrs: { "xlink:href": "#caret-circle-left" } },
                          [_vm._v("Back")]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h3", { class: _vm.mdsNS("popover__title") }, [
              _vm._v(_vm._s(_vm.title))
            ])
          ]),
          _vm._v(" "),
          _vm.showReset
            ? _c("div", { class: _vm.mdsNS("popover__buttons") }, [
                _c(
                  "button",
                  {
                    class: _vm.mdsNS("button button--icon-only"),
                    attrs: { title: "Reset Default" },
                    on: { click: _vm.clickReset }
                  },
                  [
                    _c(
                      "svg",
                      {
                        class: _vm.mdsNS(
                          "icon button__icon button__icon--right"
                        )
                      },
                      [
                        _c("use", { attrs: { "xlink:href": "#undo" } }, [
                          _vm._v("Reset Default")
                        ])
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showDone
            ? _c("div", { class: _vm.mdsNS("popover__buttons") }, [
                _c(
                  "button",
                  {
                    ref: "doneBtn",
                    class: _vm.mdsNS(
                      "button button--small button--secondary popover__button"
                    ),
                    attrs: { disabled: _vm.doneDisable },
                    on: { click: _vm.clickDone }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.doneLabel) +
                        "\n            "
                    )
                  ]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.showSearchField
        ? _c(
            "div",
            {
              class: [
                _vm.namespace("content-body__search-field"),
                _vm.mdsNS(
                  "search-field search-field--secondary search-field--small"
                )
              ],
              attrs: { role: "search" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchKey,
                    expression: "searchKey"
                  }
                ],
                class: _vm.mdsNS("search-field__input"),
                attrs: {
                  type: "text",
                  "aria-label": "Search",
                  placeholder: _vm.searchFieldPlaceholder
                },
                domProps: { value: _vm.searchKey },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchKey = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "svg",
                {
                  class: _vm.mdsNS("icon search-field__search-icon"),
                  attrs: { "aria-hidden": "true" }
                },
                [_c("use", { attrs: { "xlink:href": "#search--s" } })]
              ),
              _vm._v(" "),
              _c("span", {
                class: _vm.mdsNS("search-field__input-focus-outline")
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.mdsNS("popover__content"), _vm.namespace("__content")] },
        [_vm._t("content")],
        2
      ),
      _vm._v(" "),
      _c("footer", { class: _vm.namespace("__footer") }, [_vm._t("footer")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }